
import { mapState } from 'vuex'
import { decodeHTML } from '@/utils/deserialization'

export default {
  async fetch({ store, route, app }) {
    const id = app.$getResourceId(route.name)
    await store.dispatch('content/getContent', id)
  },
  head() {
    const langMeta =
      this.content?.meta?.lang?.map((lang) => ({
        rel: 'alternate',
        hreflang: lang.code,
        href: lang.url,
      })) || []

    return {
      title: this.content.meta?.title || this.meta?.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: decodeHTML(this.content.meta?.description || this.meta?.description),
        },
      ],
      link: [...langMeta],
    }
  },
  computed: {
    ...mapState(['content', 'meta']),
  },
  mounted() {
    // overrides legacy document links
    this.$refs?.documentContent?.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', (event) => {
        const { href, hash } = event?.target
        const communicationPreferenceLink = '/communication-preferences'
        const legacyCommunicationPreferenceLink = '?_a=newsletter'
        const legacyDocLink = 'index.php?_a=viewDoc&docId='
        const documentId = href?.split(legacyDocLink)?.[1]

        if (documentId) {
          event.preventDefault()
          this.$router.push(this.$getLink(`document/${documentId}`))
        } else if (href.includes(legacyCommunicationPreferenceLink)) {
          event.preventDefault()

          if (this.$auth.loggedIn) {
            this.$router.push(this.$getLink(communicationPreferenceLink))
          } else {
            this.$store.commit('SET_LOGIN_REDIRECT_TO', communicationPreferenceLink)
            this.$router.push(this.$getLink('/login'))
          }
        } else if (hash) {
          const idSelector = hash.replace('#', '').replace('%20', ' ')
          const anchorElementY = document.getElementById(idSelector)?.getBoundingClientRect()?.y || 0
          const parentContainerY = this.$refs.documentContent?.getBoundingClientRect()?.y || 0

          event.preventDefault()
          window.scrollTo({ top: anchorElementY - parentContainerY })
        }
      })
    })

    // overrides legacy live chat functionality
    this.$refs?.documentContent?.querySelectorAll('[data-zendesk-chat-trigger]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault()
        this.$openLiveChat()
      })
    })

    // re-adds embedded scripts
    this.$refs?.documentContent?.querySelectorAll('script').forEach((oldScript) => {
      const newScript = document.createElement('script')

      Array.from(oldScript.attributes).forEach((attribute) => newScript.setAttribute(attribute.name, attribute.value))

      if (oldScript.dataset?.jsScriptOnReload === 'true') {
        newScript.setAttribute('type', 'text/javascript')
      }
      newScript.appendChild(document.createTextNode(oldScript.innerHTML))
      oldScript.parentNode.replaceChild(newScript, oldScript)
    })
  },
}
